import React from 'react';

const ApexCollegePage = () => {
    const sectionStyle = {
        marginBottom: '2rem',
        padding: '1rem',
        borderBottom: '1px solid #ccc',
        border: '1px solid #ccc',
        borderRadius: '4px',
        color: 'white',
        backgroundColor: '#09122c',
    };

    const headingStyle = {
        color: 'white',
        fontSize: '1.5rem',
        marginBottom: '0.5rem',
        textAlign: 'left',
    };

    const listStyle = {
        marginLeft: '1.5rem',
    };

    return (
        <div style={{fontFamily: 'Arial, sans-serif', padding: '2rem', maxWidth: '800px', margin: 'auto'}}>
            <h1 style={{textAlign: 'center', color: '#34495e'}}> Apex College London Overview</h1>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>About</h2>
                <ul style={listStyle}>
                    <li>Founded: 2009</li>
                    <li>Campuses: London (Elephant & Castle) and Leicester</li>
                    <li>Specialization: Business-focused higher education</li>
                    <li>Accreditation: Pearson BTEC HND/HNC qualifications</li>
                    <li>Mission: “Education Takes You Higher”</li>
                    <li>Student Support: Academic, career, and pastoral services</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>Courses Offered</h2>
                <h3>Pearson BTEC HND/HNC Business</h3>
                <ul style={listStyle}>
                    <li>Duration: 2 years full-time</li>
                    <li>Level: 4 (HNC) and 5 (HND)</li>
                    <li>Focus: Management, marketing, finance, entrepreneurship</li>
                </ul>
                <h3>Other Programs</h3>
                <ul style={listStyle}>
                    <li>Top-up degrees via UK university partners</li>
                    <li>Short-term certifications: Project Management, HR, Marketing</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>Tuition Fees</h2>
                <br/>
                <table style={{width: '100%', borderCollapse: 'collapse'}}>

                    <thead>
                    <tr>
                        <th style={{borderBottom: '1px solid #ccc', textAlign: 'left'}}>Fee Type</th>
                        <th style={{borderBottom: '1px solid #ccc', textAlign: 'left'}}>Amount (GBP)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Tuition Fee (Annual)</td>
                        <td>£6,185</td>
                    </tr>
                    <tr>
                        <td>Enrolment Fee</td>
                        <td>£50 (non-refundable)</td>
                    </tr>
                    <tr>
                        <td>Books & IT Facilities Fee</td>
                        <td>£150 (non-refundable)</td>
                    </tr>
                    </tbody>
                </table>
                <p>Student Finance available for UK/EU students via Student Finance England.</p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>International Students</h2>
                <ul style={listStyle}>
                    <li>Visa Support: Tier 4 guidance</li>
                    <li>English Requirements: IELTS 5.5, CEFR B2, PTE 51</li>
                    <li>In-house English assessment available</li>
                    <li>Blended learning via Moodle</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>Admissions</h2>
                <ul style={listStyle}>
                    <li>Direct application (no UCAS)</li>
                    <li>Entry: BTEC Level 3, A-levels, or mature experience</li>
                    <li>Includes English writing test and interview</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}> Why Choose Apex?</h2>
                <ul style={listStyle}>
                    <li>Small class sizes</li>
                    <li>Career-focused curriculum</li>
                    <li>Diverse and inclusive environment</li>
                    <li>Urban campuses near business hubs</li>
                </ul>
            </section>
            <a href="https://apexcollege.ac.uk" target="_blank" rel="noopener noreferrer">
                <footer style={{
                    color: "white",
                    textAlign: 'center',
                    width: "fit-content",
                    marginTop: '2rem',
                    padding: "10px",
                    borderRadius:"63px",
                    backgroundColor: "#09122C",
                    fontSize: '0.9rem',
                }}>
                    Visit apexcollege.ac.uk
             for more info.
        </footer>
            </a>
</div>
)
    ;
};

export default ApexCollegePage;
